import { render, staticRenderFns } from "./FantasyLeaderboard.vue?vue&type=template&id=395b80e9&"
import script from "./FantasyLeaderboard.vue?vue&type=script&lang=js&"
export * from "./FantasyLeaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports